import _ from 'lodash';
import { FTProcess } from '@/models/FTProcess';
import { weightToPieces, initProcess, ProcessConfig, ConversionResults, ParsedVariables } from './index'
import { ConversionDetails } from '@/models/ConversionDetails';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    inputs: {
      goods: [
        {
          goodsType: 'sheet',
          goodsFilter: {
            form: ['sheet']
          },
          multiple: false,
          params: [
            {
              name: 'Width',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.width', ''),
              unit: 'mm',
              disabled: true
            },
            {
              name: 'Total Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        },
        {
          goodsType: 'adhesive',
          goodsFilter: {
            family: ['Chemical'],
            category: ['Adhesive']
          },
          multiple: false,
          params: [
            {
              name: 'Width',
              type: 'label',
              value: false,
              disablePrint: true,
              disabled: true
            },
            {
              name: 'Total Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'single',
      arguments: [
        {
          name: 'Width',
          type: 'text',
          value: 'width',
          unit: 'mm',
          disabled: false
        },
        {
          name: 'Length',
          type: 'text',
          value: 'length',
          unit: 'mm',
          disabled: false
        },
        {
          name: 'Side Gusset',
          type: 'text',
          value: 'sideGusset',
          unit: 'mm',
          disabled: false
        },
        {
          name: 'Bottom Gussert',
          type: 'text',
          value: 'BottomGussert',
          unit: 'mm',
          disabled: false
        },
        {
          name: 'With Window',
          type: 'checkbox',
          value: 'hasWindow',
          group: 1,
          disabled: false
        },
        {
          name: 'Width',
          type: 'text',
          value: 'windowWidth',
          group: 1,
          unit: 'mm',
          showIf: _.get(processRow, 'hasWindow') === true,
          disabled: false
        },
        {
          name: 'Length',
          type: 'text',
          value: 'windowLength',
          group: 1,
          unit: 'mm',
          showIf: _.get(processRow, 'hasWindow') === true,
          disabled: false
        }
      ]
    },
    tableHeaders: [
      {
        text: 'Nominal Speed',
        value: 'nominalSpeed'
      },
      {
        text: 'Piece(s) per stroke',
        value: 'pcsPerStroke'
      },
      {
        text: 'Planned Hours(s)',
        value: 'plannedHours'
      },
      {
        text: 'Number Of Pieces',
        value: 'numberOfPieces'
      },
      {
        text: 'Expected Output Waste',
        value: 'wastePercentage'
      },
      {
        text: 'Expected Output Waste Weight',
        value: 'waste'
      },
      {
        text: 'Expected Output Net Weight',
        value: 'netWeight'
      }
    ]
  }
}

export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };

  initProcess(process);

  const sheetInputProcessRow = process.inputs[0];
  const adhesiveInputProcessRow = process.inputs[1];
  const outputFTProcessRow = process.outputs[0];

  const sheetQuantity = sheetInputProcessRow.quantity ? sheetInputProcessRow.quantity : 0;
  const adhesiveQuantity = adhesiveInputProcessRow.quantity ? adhesiveInputProcessRow.quantity : 0;

  const totalInputQuantity = sheetQuantity + adhesiveQuantity;
  const totalOutputQuantity = totalInputQuantity;
  outputFTProcessRow.goodsObject.copyFrom(sheetInputProcessRow.goodsObject);
  outputFTProcessRow.goodsObject.form = 'bag-formed';
  if(sheetInputProcessRow.goodsObject.dimensions) {
    const value = weightToPieces(totalInputQuantity, sheetInputProcessRow.goodsObject.density, sheetInputProcessRow.goodsObject.dimensions.width * sheetInputProcessRow.goodsObject.dimensions.length) / totalInputQuantity;
    outputFTProcessRow.goodsObject.setPerKgRatio('plA', value);
  }
  outputFTProcessRow.goodsObject.unitWeight = sheetInputProcessRow.goodsObject.unitWeight + (adhesiveQuantity / (outputFTProcessRow.goodsObject.perKgRatio.plA.value * totalInputQuantity));
  conversionResult.outputs[0] = outputFTProcessRow;
  conversionResult.details.numberOfPieces = outputFTProcessRow.goodsObject.perKgRatio.plA.value * totalInputQuantity;
  conversionResult.details.wastePercentage = 0;
  conversionResult.details.waste = 0;
  conversionResult.details.netWeight = totalOutputQuantity;

  if (process.machineDetail.pcsPerStroke) {
      conversionResult.details.kgPerHour = 60 * outputFTProcessRow.goodsObject.unitWeight * process.machineDetail.mechanicalSpeed * process.machineDetail.pcsPerStroke;
      const pcsPerHour = 60 * process.machineDetail.mechanicalSpeed * process.machineDetail.pcsPerStroke;
      conversionResult.details.plannedHours = conversionResult.details.numberOfPieces / pcsPerHour;
  }
  conversionResult.details.pcsPerStroke = process.machineDetail.pcsPerStroke;

  return conversionResult;
}